import { green, grey } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Layout from './layout/Layout';
import { UserProvider } from './pages/login/UserContextPersistent';
import { LocalizedTagProvider } from './context/LocalizedTagContext';
import { SettingsProvider } from './context/SettingsContext';
import { LayoutProvider } from './context/LayoutContext';
import { ChatProvider } from './context/ChatContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import KalravProvider from './contexts/KalravProvider';
import { KalravWidget } from '@irisidea/kalrav-ai/react';
import { shouldTrackAnalytics, trackPageView } from './lib/analytics';

const theme = createTheme({
  palette: {
    primary: {
      main: grey[900],
    },
    secondary: {
      main: green[500],
    },
  },
});

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!shouldTrackAnalytics(location.pathname)) {
      return;
    }

    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        {/* <KalravProvider> */}
          {/* <KalravWidget 
            apiKey="16lUSyabCyNc31LZvgC69HPrlvco3N9BZXl-VDQNxbc"
            agentId="agent_0b40747c1cc8d69b"
          />  */}
          <SettingsProvider>
            <LocalizedTagProvider>
              <UserProvider>
                <LayoutProvider>
                  <ChatProvider>
                    <Router>
                      <AnalyticsTracker />
                      <Layout />
                    </Router>
                  </ChatProvider>
                </LayoutProvider>
              </UserProvider>
            </LocalizedTagProvider>
          </SettingsProvider>
        {/* </KalravProvider> */}
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
